export default __webpack_public_path__ + "static/media/YGM.89427765.mp3";